import { AbstractControl, Validators } from '@angular/forms';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import {
    equalOrMoreThanTodayOnlyIfCRCDateValidator,
    maxLengthValidator,
    notWhitespaceValidator,
} from '@utility/utility.validators';
import { Moment } from 'moment';

export class RentalCarRequestDetailsFormGroup extends PersistentFormGroup<{
    pickupAddress: PersistentFormControl<string | null>;
    pickupCountry: PersistentFormControl<string | null>;
    useFlightDate: PersistentFormControl<boolean | null>;
    pickupDate: PersistentFormControl<Moment | null>;
    pickupTime: PersistentFormControl<number | null>;
    dropOffDate: PersistentFormControl<Moment | null>;
    dropOffTime: PersistentFormControl<number | null>;
    specialRequests: PersistentFormControl<string | null>;
}> {
    public static create(value: FormGroupValueOf<RentalCarRequestDetailsFormGroup>): RentalCarRequestDetailsFormGroup {
        return new RentalCarRequestDetailsFormGroup(
            {
                pickupAddress: new PersistentFormControl(value.pickupAddress, [
                    Validators.required,
                    notWhitespaceValidator(),
                    maxLengthValidator(200),
                ]),
                pickupCountry: new PersistentFormControl(value.pickupCountry, [
                    Validators.required,
                    notWhitespaceValidator(),
                ]),
                useFlightDate: new PersistentFormControl(value.useFlightDate, [Validators.required]),
                pickupDate: new PersistentFormControl(value.pickupDate, [
                    Validators.required,
                    equalOrMoreThanTodayOnlyIfCRCDateValidator,
                ]),
                pickupTime: new PersistentFormControl(value.pickupTime, [
                    Validators.required,
                    notWhitespaceValidator(),
                ]),
                dropOffDate: new PersistentFormControl(value.dropOffDate, [
                    Validators.required,
                    equalOrMoreThanTodayOnlyIfCRCDateValidator,
                ]),
                dropOffTime: new PersistentFormControl(value.dropOffTime, [
                    Validators.required,
                    notWhitespaceValidator(),
                ]),
                specialRequests: new PersistentFormControl(value.specialRequests, [
                    notWhitespaceValidator(),
                    maxLengthValidator(1000),
                ]),
            },
            [
                (control: AbstractControl) => {
                    const typedControl = control as RentalCarRequestDetailsFormGroup;
                    const value = typedControl.getRawValue();
                    if (!value.pickupDate || !value.dropOffDate) return null;
                    const pickupDateTime = value.pickupDate.startOf('day').add(value.pickupTime, 'minutes');
                    const dropoffDateTime = value.dropOffDate.startOf('day').add(value.dropOffTime, 'minutes');
                    return pickupDateTime < dropoffDateTime
                        ? null
                        : {
                              invalidDates: 'Dropoff date and time must be later than pickup',
                          };
                },
            ]
        );
    }
}
